import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Link, useNavigate } from 'react-router-dom';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css'; 
import { useQuery, useQueryClient } from '@tanstack/react-query';
import API_URL from './api/config';

function SignupClan() {
    const navigate = useNavigate();
   
    const { data: tribeImages = [], isLoading, isError } = useQuery({
        queryKey: ['tribeImages'],
        queryFn: () =>
          axios.get(`${API_URL}/reg-signup-clan-images-api`).then((res) => {
            if (res.data.Status === "Success") {
              return res.data.images;
            } else {
              throw new Error(res.data.Message || "Failed to fetch tribe images");
            }
          }),
        staleTime: 0,
        cacheTime: Infinity,
      });

      const {
        data: tribeCaptions = [],
        isLoading: captionLoading,
        isError: captionError,
      } = useQuery({
        queryKey: ['tribeCaptions'],
        queryFn: () =>
          axios.get(`${API_URL}/reg-signup-clan-caption-api`).then((res) => {
            if (res.data.Status === "Success") return res.data.captions;
            else throw new Error("Caption fetch failed");
          }),
        staleTime: 0,
        cacheTime: Infinity,
      });


      const [selectText, setSelectText] = useState("");
      useEffect(() => {
          const fetchUserInfo = async () => {
              try {
                  const res = await axios.get(`${API_URL}/reg-signup-clan-select-text-api`, { withCredentials: true });
                  if (res.data.Status === "Success") {
                      setSelectText(res.data.selectText);
                  }
              } catch (error) {
                  console.error("Error fetching tribe select label:", error);
              }
          };
      
          fetchUserInfo();
      }, []);
    
      const [selectedClan, setSelectedClan] = useState("");
      const { data: clans = [], isLoading: tribeLoading } = useQuery({
        queryKey: ['clans'],
        queryFn: () =>
            axios.get(`${API_URL}/reg-signup-clan-api`, { withCredentials: true }).then(res => {
                if (res.data.Status === "Success") return res.data.clans;
                throw new Error("No clans found");
            }),
    });


    const handleClanSubmit = async () => {
        if (!selectedClan) {
            toast.error("Please select a clan first.");
            return;
        }

        // Handle special options
    if (selectedClan === 'no_clan') {
        navigate('/sign-up-noclan');
        return;
    }

    if (selectedClan === 'not_sure') {
        navigate('/sign-up-family');
        return;
    }
    
        try {
            const res = await axios.post(`${API_URL}/reg-signup-clan-update-api`, 
                { clan_id: selectedClan },
                { withCredentials: true }
            );
    
            if (res.data.Status === "Success") {
                navigate(res.data.redirect);
            } else {
                toast.error("Failed to update subtribe.");
            }
        } catch (error) {
            console.error("SubTribe update failed:", error);
            toast.error("Something went wrong.");
        }
    };


    return (
        

        <div
        className="min-vh-100 h-100 d-grid align-items-start"
        style={{
          backgroundImage: isLoading
            ? 'none'
            : tribeImages.length > 0
            ? `linear-gradient(rgba(0,0,0,0.7), rgba(0,0,0,0.7)), url(${API_URL}/images/${tribeImages[0].image_name})`
            : 'none',
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundRepeat: 'no-repeat'
        }}
          >
      
      
      
        <div className="row align-items-center g-3 container m-auto">
          
          <div className="col-12 col-md-6 text-white">
            <p className="display-5">
            {captionLoading ? 'Loading caption...' : (
                    tribeCaptions.map((caption, index) => (
                        <span key={index}>{caption.caption}</span>
                    ))
                    )}
            </p>
          </div>
      
          <div className="col-12 col-md-5 col-xl-4 mx-auto">
            <div className="card bg-secondary text-white">
              <div className="card-body">
                <p className="h4 text-center">{selectText}</p>
               
                  <div className="row g-3 align-items-end">
                    <div className="col-12">
                    <ToastContainer />
      
                    <select className="form-select"
                                    value={selectedClan}
                                    onChange={(e) => setSelectedClan(e.target.value)}
                                >
                                    <option value="">Select Clan</option>
                                    {tribeLoading ? (
                                        <option disabled>Loading clan...</option>
                                    ) : (
                                        clans.map((clan) => (
                                            <option key={clan.id} value={clan.id}>
                                                {clan.name}
                                            </option>
                                        ))
                                    )}

                                    
                                    <option value="no_clan" style={{fontWeight: '900'}}>Insert your clan</option>
                                    <option value="not_sure" style={{fontWeight: '900'}}>I'm not sure</option>
                                </select>

                                
                    </div>
      
                    <div className="col-12 mb-3">
                      <div className="d-flex justify-content-between">
                      <Link onClick={() => navigate(-1)} class="btn btn-back">Back</Link>
                        <button
                          onClick={handleClanSubmit} className="btn btn-primary" type="submit"
                        >
                          Continue
                        </button>
                      </div>
                    </div>
                  </div>
                
              </div>
            </div>
          </div>
        </div>
      </div>


    );
}

export default SignupClan;
